export class RetrieveCoveragesCompleteRequest {
  businessLine: string

  constructor(data: any = {}) {
    this.businessLine = data.businessLine
  }
}
